/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(String)],
  props: {
    role: {type: String, default: ''},
    type: {type: String, default: ''},
  },
  emits: ['delete', 'change-role'],
  data() {
    return {
      valid: true
    }
  },
  computed: {
    placeholder() {
      return this.type === 'placeholder'
    }
  },
  methods: {
    onResize() {
      this.$refs.textarea?.startUpdateRows()
    },
    changeRole(){
      this.$emit('change-role', this.role)
    }
  }
}
